import { render, staticRenderFns } from "./new-resetpass.vue?vue&type=template&id=339bd4e6"
import script from "./new-resetpass.vue?vue&type=script&lang=js"
export * from "./new-resetpass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports